import Vue from 'vue'
import Vuex from 'vuex'

import common from './common'
import auth from './authModule'
import project from './project'
import advancedWeldLog from './advancedWeldLog'
import unsavedChanges from './unsavedChanges'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    auth,
    project,
    advancedWeldLog,
    unsavedChanges
  }
})
